// extracted by mini-css-extract-plugin
export var closeButton = "_jc-2";
export var closeButtonIcon = "_jc-3";
export var lightboxContent = "_jc-1";
export var lightboxOverlay = "_jc-0";